module.exports = __webpack_public_path__ + "img/Gh_Sincai_Indreptare_catra_aritmetica_Blaj_1785.35d6de6c.png";